"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdReactRouter = require("cccisd-react-router");
var _cccisdLaravelBoilerplate = require("cccisd-laravel-boilerplate");
var _RedeemVoucher = _interopRequireDefault(require("./components/RedeemVoucher"));
var _RoleSelector = _interopRequireDefault(require("./components/RedeemVoucher/RoleSelector"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Root = function Root(props) {
  return /*#__PURE__*/_react["default"].createElement(_cccisdReactRouter.Switch, null, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
    exact: true,
    path: "".concat(props.match.url, "/voucher/redeem/:code/select-role"),
    component: _RoleSelector["default"],
    componentProps: props
  }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
    path: ["".concat(props.match.url, "/voucher/redeem/:code"), "".concat(props.match.url, "/voucher/redeem/:code/role-selected")],
    component: _RedeemVoucher["default"],
    componentProps: props
  }));
};
var _default = exports["default"] = Root;